import { FC } from 'react';
import GettingStartedDemoDashboard from '../../Demo/GettingStartedDashboards/GettingStarted';

const GettingStartedDemo: FC = () => <GettingStartedDemoDashboard />;

export default GettingStartedDemo;
